import React from 'react';
import { Images } from '../../../assets/assets';
import { Link } from 'react-router-dom'; // React Router
import {
	// faTwitter,
	// faPinterestP,
	// faYoutube,
	faFacebookF,
} from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default function FooterAbout() {
	const socialLinks = [
		// { icon: faTwitter, url: "https://twitter.com", name: "Twitter" },
		// { icon: faPinterestP, url: "https://pinterest.com", name: "Pinterest" },
		// { icon: faYoutube, url: "https://youtube.com", name: "YouTube" },
		{ icon: faFacebookF, url: "https://www.facebook.com/5StarGrading/", name: "Facebook" },

	];
	return (
		<div className="fooger-logo text-center">
			<h5 className='text-white midium-heading'>Lets Talk Dirt!!!</h5>
			<div className='footer-btn-holder mt-xl-4 mt-lg-3 mt-2'>
				<Link to="/contact-us" className="btn hero-btn btn-solid-orange">
					<span className="fw-bold me-3 ">Contact Us</span>
					<img className="img-fluid" src={Images.FancyCornerIcon} alt="Phone icon" />
				</Link>
			</div>
			<div className='footer-social-links-wraper mt-xl-4 mt-3'>
				<ul className=" list-unstyled d-flex gap-3">
					{socialLinks.map(({ icon, url, name }, index) => (
						<li key={index}>
							<a
								href={url}
								target="_blank"
								rel="noopener noreferrer"
								className="social-icon d-flex justify-content-center align-items-center rounded-circle"
								aria-label={name}
								title={name}
							>
								<FontAwesomeIcon icon={icon} size="sm" />
							</a>
						</li>
					))}
				</ul>
			</div>
		</div>
	);
}
